import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { ButtonComp } from 'atoms/Buttons';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { OTP_SCREEN } from '../../Constants/Constants';
import Modal from 'molecules/Modal';
import OtpTimer from '../../Presentation/AccountSettings/OtpTimer';

const OtpScreen = props => {
  const {
    closeOtpModalHandler,
    otpSendTo,
    callValidateOtpAPI,
    callResendOtpAPI,
    isOtpMatch,
    hideError,
    invalidOtpCount,
  } = props;
  const { SUBMIT_BUTTON_TEXT, SENT_AN_SMS, OTP_SENT_TEXT, INVALID_OTP } = OTP_SCREEN;
  const [disabledOtpLink, setDisabledOtpLink] = useState(false);
  const expectedOTPLength = 4;
  const [enableSubmitBtn, setEnableSubmitBtn] = useState(false);

  const [timerValue] = useState(179); // Otp timer timings setting here i.e. 2:59
  let initialState = {
    0: '',
    1: '',
    2: '',
    3: '',
  };
  const [otp, setOtp] = useState(initialState);
  const [otpData, setOtpData] = useState(initialState);
  const checkIsNumber = event => {
    if ((event.which !== 8 && event.which !== 0 && event.which < 48) || event.which > 57) {
      event.preventDefault();
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    let enterdOtpLength = Object.values(otpData).join('').length;
    if (expectedOTPLength === enterdOtpLength) {
      setEnableSubmitBtn(true);
    } else {
      setEnableSubmitBtn(false);
      hideError();
    }
  });

  const setOptValues = (event, index) => {
    let value = event.target.value;
    setOtp(previousVal => ({
      ...previousVal,
      [index]: value,
    }));

    setOtpData(previousVal => ({
      ...previousVal,
      [index]: value,
    }));
  };

  const CustomizeModalProps = {
    // id: 'CustomizedModal',
    closeDataTestId: 'close-otp-testId',
    role: 'dialog',
    show: true,
    classNames: 'customized-otp-modal',
    showCloseBtn: true,
    closeButtonHandler: closeOtpModalHandler,
    modalTitle: translateWithI18Next(SENT_AN_SMS),
  };

  const getCodeBoxElement = index => {
    return document.getElementById('codeBox' + index);
  };
  const onKeyUpEvent = (event, index) => {
    const eventCode = event.which || event.keyCode;
    if (getCodeBoxElement(index).value.length === 1) {
      if (index !== expectedOTPLength - 1) {
        getCodeBoxElement(index + 1).focus();
      } else {
        getCodeBoxElement(index).blur();
      }
    }
    if (eventCode === 8 && index !== 0) {
      getCodeBoxElement(index - 1).focus();
    }
  };

  const otpInputOnBlur = index => {
    setOtp(previousVal => ({
      ...previousVal,
      [index]: otpData?.[index],
    }));
  };

  const otpInputOnFocus = index => {
    setOtp(previousVal => ({
      ...previousVal,
      [index]: '',
    }));

    setOtpData(previousVal => ({
      ...previousVal,
      [index]: '',
    }));
  };

  const resendOtpHandler = event => {
    event.preventDefault();
    callResendOtpAPI();
    setDisabledOtpLink(true);
    setTimeout(() => {
      setDisabledOtpLink(false);
    }, 30000);
  };

  const validatedOtp = () => {
    let enteredOtpValue = Object.values(otpData).join('');
    callValidateOtpAPI(enteredOtpValue);
  };
  const clearOtpHandler = () => {
    setOtp(() => initialState);
    setOtpData(() => initialState);
  };
  const otpTemplate = (
    <Modal {...CustomizeModalProps}>
      <div className='otp-main-container'>
        <div className='left-section'>
          {' '}
          <div>{translateWithI18Next(SENT_AN_SMS)}</div>
        </div>
        <div className='right-section'>
          <div className='otp-title-text'>{translateWithI18Next(OTP_SENT_TEXT)}.</div>
          <div className='sendto'>{otpSendTo}</div>
          <div className='otpDiv' aria-describedby='otpInvalid'>
            {[...Array(expectedOTPLength)].map((otpnum, index) => {
              return (
                <input
                  key={`key${index}`}
                  id={`codeBox${index}`}
                  data-testid={`otp-testid-${index}`}
                  className={`otpNum ${!isOtpMatch ? 'otpNum-invalid' : ''}`}
                  type={'tel'}
                  maxLength={1}
                  onKeyPress={event => checkIsNumber(event)}
                  onKeyUp={event => onKeyUpEvent(event, index)}
                  onChange={event => setOptValues(event, index)}
                  onBlur={() => otpInputOnBlur(index)}
                  onFocus={() => otpInputOnFocus(index)}
                  value={otp?.[index]}
                />
              );
            })}
            {!isOtpMatch && (
              <img
                data-testid='clear-otp-testid'
                className=''
                src={IMAGE_PATH.Clear_icon}
                alt='clear otp'
                onClick={clearOtpHandler}
              />
            )}
          </div>

          {!isOtpMatch && (
            <div className='otp-error-text dob-error-show'>
              <span>
                <img src={IMAGE_PATH.Error} alt='Error visible' />
              </span>
              {translateWithI18Next(INVALID_OTP)} {`(${invalidOtpCount}/3)`}
            </div>
          )}

          <div className='otp-expired-text'>
            <OtpTimer timeSrc={timerValue} resendOtpHandler={resendOtpHandler} disabledOtpLink={disabledOtpLink} />
          </div>

          <div className='buttons-container'>
            <ButtonComp
              className={`buttons-group ${enableSubmitBtn ? 'save' : 'save-disabled'}`}
              data-testid='update-account-button-testid'
              onClickHandler={() => validatedOtp()}
              disabled={!enableSubmitBtn}
            >
              {translateWithI18Next(SUBMIT_BUTTON_TEXT)}
            </ButtonComp>
          </div>
        </div>
      </div>
    </Modal>
  );

  return ReactDOM.createPortal(otpTemplate, document.getElementById('modal-popups'));
};

export default OtpScreen;
